import React from 'react'
import { WorksheetCard } from './worksheetCard/worksheetCard';
import './styles.scss';
import { useAppMediaProvider } from '../../../baseStyles/AppMediaProvider';
import { DeviceTypes } from '../../../baseStyles/AppMediaProvider';
import DiscoverMoreSvg from './discover-more.svg'
import RightArrowSvg from './right-arrow.svg';
import { PRINTABLE_WORKSHEET_SCREENS, usePrintableWorksheetsState, SubjectCodes } from 'printableWorksheets/state';
import { IMobileState, ITreeItem } from '../worksheetsNav/topicSelector';
import { WorksheetsEnvironment } from 'printableWorksheets';
import Scroller from 'schoolUiComponents/Scroller';
import FlexBox from 'schoolUiComponents/basic/Box/FlexBox';
interface IWorksheetRailProps {
    worksheets: Array<any>;
    title: string;
    playblesCount: number;
    nodeId: string;
    item: any;
}

const WorksheetRail: React.FC<IWorksheetRailProps> = ({
    worksheets = [],
    title = 'Untitled',
    playblesCount = 0,
    nodeId = "",
    item = {}
}) => {

    const { currentDevice } = useAppMediaProvider();
    const { setActiveScreen, setSearchScreenData, activeBreadcrumb, setActiveBreadcrumb, treeData, worksheetsEnvironment, subjectCode } = usePrintableWorksheetsState();

    const switchToViewAllPage = async (): Promise<void> => {
        setSearchScreenData({ nodeId, title, from: 'RAILS' });
        setActiveScreen(PRINTABLE_WORKSHEET_SCREENS.SEARCH)
    }

    const findItemInNodeList = (data: ITreeItem, itemId: string): ITreeItem => {
        if (data.id.toString() === itemId) {
            return data
        } else {
            let res: ITreeItem | null = null;
            for (let i = 0; i < data.children.length; i++) {
                res = findItemInNodeList(data.children[i], itemId);
                if (res) {
                    break;
                }
            } if (res) {
                return res;
            }
        }
    }

    if (worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD) {
        return (
            <div className={`ws-rail`}>
                <Scroller onScrollChange={(value) => { }}>
                    <div className="ws-rail__header">
                        <div className="title">{title}</div>
                        <FlexBox gap={16}>
                            <div
                                className="view-printables"
                                // onClick={() => switchToViewAllPage()}
                                onClick={() => {
                                    let item = activeBreadcrumb?.[0]?.title == 'Math' ? findItemInNodeList(treeData[1], nodeId) : findItemInNodeList(treeData[0], nodeId);
                                    if (activeBreadcrumb?.[activeBreadcrumb?.length - 1]?.id != item.id) {
                                        setActiveBreadcrumb([...activeBreadcrumb, item]);
                                    }
                                }}
                            >
                                {`View all ${playblesCount}${playblesCount > 1 ? ` worksheets` : `worksheet`}`}
                            </div>
                            <FlexBox gap={8}>
                                <Scroller.Prev />
                                <Scroller.Next />
                            </FlexBox>
                        </FlexBox>
                    </div>
                    <Scroller.Box>
                        <FlexBox gap={20} fullWidth>
                            {worksheets.map((worksheet: any, index: any) => {
                                if (index == worksheets.length - 1 && currentDevice === DeviceTypes.Mobile) {
                                    return (
                                        <React.Fragment key={worksheet.id}>
                                            <WorksheetCard card={worksheet} />
                                            <div className="discover-more-container" onClick={() => switchToViewAllPage()}>
                                                <div className="playbles-count">+{playblesCount}</div>
                                                <DiscoverMoreSvg />
                                            </div>
                                        </React.Fragment>
                                    )
                                } else {
                                    return (
                                        <React.Fragment key={worksheet.id}>
                                            <WorksheetCard card={worksheet} />
                                        </React.Fragment>
                                    )
                                }
                            })}
                        </FlexBox>
                    </Scroller.Box>
                </Scroller>
            </div>
        )
    }

    return (
        <div className={`ws-rail student ${currentDevice === DeviceTypes.Mobile ? ' ws-rail-mobile-view' : ''}`}>
            <div className="ws-rail__header student">
                <div className="title student">{title}</div>
                {currentDevice !== DeviceTypes.Mobile && (
                    <div
                        className="view-printables-student"
                        // onClick={() => switchToViewAllPage()}
                        onClick={() => {
                            let item = activeBreadcrumb?.[0]?.title == 'Math' ? findItemInNodeList(treeData[1], nodeId) : findItemInNodeList(treeData[0], nodeId);
                            if (activeBreadcrumb?.[activeBreadcrumb?.length - 1]?.id != item.id) {
                                setActiveBreadcrumb([...activeBreadcrumb, item]);
                            }
                        }}
                    >
                        {`View all ${playblesCount}${playblesCount > 1 ? ` worksheets` : ` worksheet`}`}
                        <RightArrowSvg/>
                    </div>
                )}
            </div>
            <div className={`ws-rail__list${worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD ? ' student-rail' : ''}`}>
                {worksheets.map((worksheet: any, index: any) => {
                    if (index == worksheets.length - 1 && currentDevice === DeviceTypes.Mobile) {
                        return (
                            <React.Fragment key={worksheet.id}>
                                <WorksheetCard card={worksheet} />
                                <div className="discover-more-container" onClick={() => switchToViewAllPage()}>
                                    <div className="playbles-count">+{playblesCount}</div>
                                    <DiscoverMoreSvg />
                                </div>
                            </React.Fragment>
                        )
                    } else {
                        return (
                            <React.Fragment key={worksheet.id}>
                                <WorksheetCard card={worksheet} />
                            </React.Fragment>
                        )
                    }
                })}
            </div>
        </div>
    )
}

export default WorksheetRail;